import { SET_USER_RESTAURANTS } from "../action/types";

export default function restaurantReducer(
  state = {
    restaurants: [],
  },
  action
) {
  switch (action.type) {
    case SET_USER_RESTAURANTS:
      return {
        ...state,
        restaurants: action.payload,
      };

    default:
      return state;
  }
}
